<template>
  <div class="drawer-wapper-info">
    <div class="main-info">
      <el-form ref="form" :model="formData" :rules="rules" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              prop="platformId"
              :label="$l('form_label_platformId') || '平台id'"
            >
              <el-input
                v-model="formData.platformId"
                :disabled="disabled"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="30"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="platformName"
              :label="$l('form_label_platformName') || '平台名称'"
            >
              <el-input
                v-model="formData.platformName"
                :disabled="disabled"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="platformType"
              :label="$l('form_label_platformType') || '平台类型'"
            >
              <el-select
                v-model="formData.platformType"
                clearable
                :disabled="disabled"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in platformTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-form-item
            prop="platformType"
            :label="$l('form_label_paramsTemplate') || '参数模版'"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              v-model="formData.paramsTemplate"
              :disabled="disabled"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              size="small"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="d-flex justify-content-end mt-4 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
    <div>
      <ItemTable
        ref="itemTable"
        :disabled="disabled"
        :platformCode="platformCode"
      />
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import ItemTable from './item-table'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: { ItemTable },
  props: {
    disabled: { type: Boolean, default: false },
    platformCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      platformTypeOptions: [
        { label: '电商平台', value: 'E' },
        { label: '仓库', value: 'W' },
      ],
      backDialogVisible: false,
      rules: {
        platformId: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.platformCode) return
      this.$api
        .ecomPlatformDetailApi({
          platformCode: this.platformCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      this.$api
        .ecomPlatformSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.platformCode) {
            await this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      console.log(this.$route.fullPath)
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-wapper-info {
  padding: 0 20px;
}
</style>
